export function getOrDefault(value, defaultValue) {
    if (value === null || value === undefined) {
        return defaultValue;
    }
    if (typeof value === 'number' && isNaN(value)) {
        return defaultValue;
    }
    return value;
}
